<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="alert mt-3 ml-md-4 mb-0" role="alert"
     [class.alert-success]="history.state.feedback.status == 'success'"
     [class.alert-info]="history.state.feedback.status == 'info'"
     *ngIf="history && history.state && history.state.feedback">
  {{ history.state.feedback.text }}
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="serverError === null">

  <h2>
    Associations
    <span *ngIf="loadingAssociations" class="text-secondary">- Loading...</span>
    <span *ngIf="!loadingAssociations && associationList && associationList.results">({{ associationList.count.toLocaleString() }})</span>
  </h2>

  <div class="row">
    <div class="col-xl-5 col-12 mb-3">
      <input type="text" class="form-control"
             placeholder="Filter associations by name"
             [(ngModel)]="filters.search"
             (ngModelChange)="this.filtersChangedSubject.next()">
    </div>
    <div class="col-xl-7 col-12 mb-3 clearfix">
      <button class="btn btn-success float-right" type="button" (click)="handleCreateNewAssociation()">
        Create New Association
      </button>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Name</th>
        <th># Members</th>
      </tr>
      </thead>

      <tbody *ngIf="resultsPresent()">
      <tr *ngFor="let association of associationList.results"
          style="cursor: pointer"
          routerLink="/associations/{{ association.id }}">
        <td>{{ association.name }}</td>
        <td>{{ association.num_members }}</td>
      </tr>
      </tbody>

      <tbody *ngIf="!resultsPresent()">
      <tr>
        <td colspan="99" class="text-muted">
          {{ loadingAssociations ? 'Loading...' : 'No associations' }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSize" (change)="setPage(1)">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</div>
